import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import "./DeleteTraining.css";

function DeleteTraining() {
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { tid } = useParams();

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/${tid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setName(response.data.training.name);
    }
    fetch();
    setIsLoading(false);
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainings/${tid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings");
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="delete-training">
            <Col>
              <h4>{t("Capacitaciones.Capacitacion.DeleteTraining.Titulo")}</h4>
            </Col>
            <Col className="delete-training-form">
              <Col className="mb-1">
                <p>
                  {t("Capacitaciones.Capacitacion.DeleteTraining.Pregunta")}
                </p>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Capacitaciones.Capacitacion.DeleteTraining.Eliminar")}
                </Button>
                <Button
                  className="danger"
                  onClick={() => navigate("/trainings")}
                >
                  {t("Capacitaciones.Capacitacion.DeleteTraining.Cancelar")}
                </Button>
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DeleteTraining;
